import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const sizes = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby={title ? 'modal-title' : undefined} data-id="element-859" data-mp="2i3pknkxkyhnu">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-860" data-mp="2n2ab4sn15mz3" />
      <div className={`relative bg-white rounded-2xl shadow-xl w-full ${sizes[size]} max-h-[90vh] overflow-auto animate-in fade-in zoom-in-95 duration-200`} data-id="element-861" data-mp="2859srfqqb4da">
        {title && <div className="flex items-center justify-between p-4 border-b border-gray-100" data-id="element-862" data-mp="1zc6ifgbdr7mv">
            <h2 id="modal-title" className="text-lg font-semibold text-gray-900" data-id="element-863" data-mp="2446akml7kw8w">
              {title}
            </h2>
            <button onClick={onClose} className="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" aria-label="Close modal" data-id="element-864" data-mp="1pgd0fhew6lxp">
              <XIcon className="w-5 h-5" data-id="element-865" data-mp="1gdtwetzde39v" />
            </button>
          </div>}
        <div className={title ? 'p-4' : 'p-4'} data-id="element-866" data-mp="1ggpx2q2lr620">
          {!title && <button onClick={onClose} className="absolute top-4 right-4 p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" aria-label="Close modal" data-id="element-867" data-mp="1kffgp0e8hju3">
              <XIcon className="w-5 h-5" data-id="element-868" data-mp="3iaum25kpnk3c" />
            </button>}
          {children}
        </div>
      </div>
    </div>;
}